import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["border", "className", "controlIcon", "controlIconLabel", "external", "externalLinkText", "fwdRef", "href", "onBlur", "onClick", "onFocus", "target"];
import React, { forwardRef, useState } from 'react';
import { IconLinkInternal } from '@op/opds.opux-icons/navigation';
import { buildVersionedClass, buildVersionedClassNames } from '@op/opds.opux-utilities';
import { Button } from '../../../button/button';
/**
 * _An interactive table cell that links or performs an immediate action._
 *
 * ***
 *
 * The component is displayed as a table cell with an icon inside of it.
 * It renders either an `<a>` or a `<button>` element inside its rendered `<td>`
 * depending on the use of the `href` or the `onClick`.
 *
 * The component can be used independently on a table row to provide an
 * interactive cell or it can be used within a [`TableRowSegment`](#/Lists%20%26%20Tables/TableRowSegment)
 * to provide the interactivity for the whole segment with the mouse and touch use.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping `<td>` element.
 */
export const TableActionCell = _ref => {
  let {
      border,
      className,
      controlIcon,
      controlIconLabel,
      external,
      externalLinkText,
      fwdRef,
      href,
      onBlur,
      onClick,
      onFocus,
      target
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [active, setActive] = useState(false);
  return /*#__PURE__*/React.createElement("td", _extends({
    align: "center",
    className: buildVersionedClassNames('ds-table-action-cell', className, {
      'ds-table-action-cell--active': active,
      'ds-table-action-cell--border-right': border === 'right',
      'ds-table-action-cell--border-none': border === 'none'
    }),
    ref: fwdRef
  }, props), /*#__PURE__*/React.createElement("div", {
    className: buildVersionedClass('ds-table-action-cell__button-wrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    compact: true,
    external: external,
    externalLinkText: externalLinkText,
    ghost: true,
    href: href,
    icon: controlIcon != null ? controlIcon : IconLinkInternal,
    iconLabel: controlIconLabel,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onMouseDown: () => setActive(true),
    onMouseUp: () => setActive(false),
    onMouseLeave: () => setActive(false),
    target: target
  })));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(TableActionCell, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'TableActionCell';
export default Fwd;